import './Footer.scss'
import {Link }  from '@fluentui/react-components';

function Footer()
{
    return (
        <div className='container footer-color'>
            <hr/>
            <div className='footer-color d-flex justify-content-between'>
                <div>
                    <span><strong>Contact</strong></span>
                    <p>Email: <i>support@wrypai.com</i></p>
                </div>
                <div className='align-end'>
                    <span><Link href="/privacypolicy">Privacy Policy</Link></span>
                    <p>© 2025. All rights reserved.</p>                
                </div>
            </div>
            <div className='d-flex justify-content-center'>
                <div className='created-by'>
                    Created by: Angel Bello
                </div>
            </div>
        </div>
    );
}

export default Footer;